/**
 * Shortest query the admin account search will run. The scan is a sequential
 * `ILIKE '%q%'` over families and users — no index can serve it — so a
 * one-character needle costs a full pass and matches most of the fleet.
 *
 * Shared so the operator UI can say "type at least N characters" using the
 * same number the server enforces, rather than reporting a short query as
 * "no households found".
 */
export const MIN_ACCOUNT_SEARCH_LENGTH = 2;

/**
 * Households one search returns at most. A query this wide is an operator
 * narrowing in on one household, not paging a list, so the cap is a runaway
 * bound rather than a page size — there is no cursor.
 *
 * Shared so the UI can say a full result set was truncated. Without the
 * number, a capped result is indistinguishable from a complete one and the
 * operator narrows a query that was already hiding the match.
 */
export const ACCOUNT_SEARCH_LIMIT = 50;
